import BackendApiClient from './BackendApiClient';

class MenuManager {
  getCategories = () =>
    BackendApiClient.requestAuthorized({
      method: 'GET',
      url: '/staff/categories',
    });

  updateProduct = (id, data) =>
    BackendApiClient.requestAuthorized({
      method: 'PUT',
      url: `/staff/products/${id}`,
      data,
    });

  getModifierGroups = () =>
    BackendApiClient.requestAuthorized({
      method: 'GET',
      url: '/staff/modifier-groups',
    });

  updateModifierGroup = (id, data) =>
    BackendApiClient.requestAuthorized({
      method: 'PUT',
      url: `/staff/modifier-groups/${id}`,
      data,
    });

  updateModifier = (id, data) =>
    BackendApiClient.requestAuthorized({
      method: 'PUT',
      url: `/staff/modifiers/${id}`,
      data,
    });

  toggleModifierGroupVisible = (modifierGroup) =>
    this.updateModifierGroup(modifierGroup.id, {
      ...modifierGroup,
      is_visible: !modifierGroup?.is_visible,
    });

  toggleModifierAvailable = (modifier) =>
    this.updateModifier(modifier.id, {
      ...modifier,
      is_available: !modifier?.is_available,
    });
}

export default new MenuManager();
